import React, { useState, useContext } from 'react';
import { AppContext } from '../../App';
import { api } from '../../utils/api';

interface MfaVerifyModalProps {
    mfaToken: string;
    onClose: () => void;
}

const MfaVerifyModal: React.FC<MfaVerifyModalProps> = ({ mfaToken, onClose }) => {
    const appContext = useContext(AppContext);
    const [code, setCode] = useState("");
    const [rememberDevice, setRememberDevice] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        if (!appContext) {
            setError("Application context error.");
            setLoading(false);
            return;
        }

        try {
            const data = await api.post<any>('/api/v1/auth/mfa/login-verify', { mfa_token: mfaToken, token: code, rememberDevice });
            appContext.handleLogin(data.token, data.user);
            onClose();

        } catch (err) {
            if(err instanceof Error) setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
            <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-sm" onClick={(e) => e.stopPropagation()}>
                <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">Two-Factor Authentication</h2>
                <p className="text-gray-600 mb-6 text-center">Enter the code from your authenticator app.</p>
                
                <form onSubmit={handleSubmit}>
                    {error && <p className="text-red-500 text-center mb-4">{error}</p>}
                    <label htmlFor="mfa-login-code" className="sr-only">Verification Code</label>
                    <input
                        id="mfa-login-code"
                        type="text"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        className="w-full p-4 border border-gray-300 rounded-md text-center text-3xl font-mono tracking-widest"
                        placeholder="123456"
                        maxLength={6}
                        required
                        autoFocus
                    />

                    <div className="mt-4 flex items-center justify-center">
                        <input
                            id="remember-device"
                            type="checkbox"
                            checked={rememberDevice}
                            onChange={(e) => setRememberDevice(e.target.checked)}
                            className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                        <label htmlFor="remember-device" className="ml-2 block text-sm text-gray-700">
                            Remember this device for 30 days
                        </label>
                    </div>

                    <button type="submit" className="w-full mt-6 py-3 bg-blue-600 text-white rounded-md font-semibold text-lg hover:bg-blue-700 transition" disabled={loading}>
                        {loading ? 'Verifying...' : 'Verify'}
                    </button>
                </form>
                 <div className="text-center mt-4">
                    <button onClick={onClose} className="text-sm text-gray-500 hover:underline">Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default MfaVerifyModal;